<button
  class="btn btn-link btn-sm column-manager-trigger"
  type="button"
  data-test-id="column-manager-open"
  (click)="openPopup()">
  {{ buttonLabel | mrTranslate }}
</button>

<clr-modal
  [clrModalOpen]="isOpen"
  (clrModalOpenChange)="setOpen($event)"
  [clrModalClosable]="true"
  [clrModalSize]="'sm'"
  data-test-id="column-manager-modal">
  <h3 class="modal-title text-left">{{ popupTitle | mrTranslate }}</h3>

  <div class="modal-body">
    <div
      class="column-manager-list"
      data-test-id="column-manager-list"
      cdkDropList
      [cdkDropListData]="items"
      (cdkDropListDropped)="moveItem($event)">
      @for (item of items; track item.id) {
        <div class="column-manager-item" [attr.data-test-id]="'column-manager-item-' + item.id" cdkDrag>
          <button class="drag-handle" type="button" cdkDragHandle [attr.aria-label]="'Sortieren' | mrTranslate">
            <cds-icon shape="ellipsis-vertical" size="12" />
          </button>

          <span class="column-label">{{ item.label | mrTranslate | titlecase | mrUnitText }}</span>
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closePopup()">{{ 'Schließen' | mrTranslate }}</button>
  </div>
</clr-modal>
